import { api } from "@services/AxiosBootstrap";

class Client {

    constructor()
    {
        this.apiUrl = location.origin + '/api/';
    }

    axios() {
        return api;
    }

    uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
            .replace(/[xy]/g, function (c) {
                const r = Math.random() * 16 | 0,
                    v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
    }

    async postData(uri = '', data = {})
    {
        const url = this.apiUrl + this.removeLeadingSlash(uri);
        const myHeaders = new Headers();
        myHeaders.append('Accept', 'application/json');
        myHeaders.append('Content-Type', 'application/json');
        myHeaders.append('X-CSRF-TOKEN', document.querySelector('meta[name="csrf-token"]').content);
        myHeaders.append('X-TRACE-ID', this.uuidv4());

        const raw = JSON.stringify(data);

        const requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        return fetch(url, requestOptions);
    }

    async getData(uri = '')
    {
        const url = this.apiUrl + this.removeLeadingSlash(uri);
        const myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');
        const requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };
        return fetch(url, requestOptions);
    }

    removeLeadingSlash(str) {
        if (str.startsWith('/')) {
            return str.substring(1); // Remove the first character (which is '/')
            // Alternatively, you can use:
            // return str.slice(1); // Remove the first character (which is '/')
        }
        return str; // If the string doesn't start with '/', return it unchanged
    }
}

const HttpClient = new Client();
export default HttpClient;
